import { useEffect } from 'react';
import SegmentedWithCountBadge from 'components/new-ui/composed/segmented-with-count-badge/SegmentedWithCountBadge';
import { InvoicesStatuses } from 'store/invoices/types';
import { DashboardInvoicesData } from 'views/invoices/types';

const activeOptions = (counts: DashboardInvoicesData) => [
    { value: 'ALL', label: 'All', badges: counts.all },
    { value: InvoicesStatuses.DRAFT, label: 'Draft', badges: counts.draft },
    { value: InvoicesStatuses.AWAITING_PAYMENT, label: 'To Be Paid', badges: counts.toBePaid },
    { value: InvoicesStatuses.PAID, label: 'Paid', badges: counts.paymentReceived },
    { value: InvoicesStatuses.PARTIALLY_PAID, label: 'Partially Paid', badges: counts.partiallyPaid },
    { value: InvoicesStatuses.TO_BE_DUE, label: 'Due', badges: counts.aboutToBeDue },
    { value: InvoicesStatuses.OVERDUE, label: 'Overdue', badges: counts.overdue },
    { value: InvoicesStatuses.DISPUTED, label: 'Disputed', badges: counts.disputed },
    { value: InvoicesStatuses.CANCELLED, label: 'Cancelled', badges: counts.cancelled },
];

const archivedOptions = (counts: DashboardInvoicesData) => [
    { value: 'ALL', label: 'All', badges: counts.all },
    { value: InvoicesStatuses.PAID, label: 'Paid', badges: counts.paymentReceived },
    { value: InvoicesStatuses.CANCELLED, label: 'Cancelled', badges: counts.cancelled },
];

const VALID_ARCHIVED_VALUES = [InvoicesStatuses.PAID, InvoicesStatuses.CANCELLED, 'ALL'];

type Props = {
    value: string;
    counts: DashboardInvoicesData;
    archived?: boolean;
    onChange: (val: InvoicesStatuses | 'ALL') => void;
};

const InvoicesStatusSegmented = ({ value, counts, archived, onChange }: Props) => {
    useEffect(() => {
        if (archived && !VALID_ARCHIVED_VALUES.includes(value)) {
            onChange('ALL');
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [archived]);

    return (
        <SegmentedWithCountBadge
            showZero
            value={value}
            onChange={onChange}
            options={archived ? archivedOptions(counts) : activeOptions(counts)}
        />
    );
};

export default InvoicesStatusSegmented;
